var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('TruncateHelper',{attrs:{"title":_vm.title,"maxWidth":_vm.maxWidth}},[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.title)+" ")],1),_vm._t("action")],2),_c('v-expansion-panel-content',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }